module.exports = __webpack_public_path__ + "static/media/free-training.2ef50fa7.svg";